// @ts-nocheck
//FIXME: fix the types in the api
import { all } from "axios";
import { OptionsType, togaApiRequest } from "../../../api/toga";
import { Invoice, OrderDetails } from "../OrdersInterfaces";
import { Console } from "console";

export interface Field {
	[key: string]: string | string[] | Field;
}

export interface ExtendedOptionsType extends Omit<OptionsType, "fields"> {
	depth?: number;
	fields?: (
		| string
		| Field
		| { location: string[]; shipToAddress: string[] }
	)[];
	where?: any;
	join?: any;
	ojoin?: any;
	sort?: any;
	recordsPerPage?: number;
	page?: number;
	[key: string]: any;
}

interface GetOrdersOptions extends ExtendedOptionsType { }

/* --------------------------------------- PRUDENTIAL ORDERS -------------------------------------- */

//hard-coded logic to pull prudential orders to export to CSV
export async function getPrudentialOrders() {
	const options: ExtendedOptionsType = {
		recordsPerPage: 1000,
		fields: [
			"PurchaseOrders.number",
			"dateShipped",
			"PurchaseOrderStages.name",
			"PurchaseOrders.c_dtTransmittedInProgressUpdateToPrudential",
			"PurchaseOrders.c_dtTransmittedOrderShippedUpdateToPrudential",
			"PurchaseOrders.c_dtTransmittedOrderClosedUpdateToPrudential",
			"SalesOrders.number",
			"SalesOrders.dateOrder",
			"Addresses.line1",
			"Addresses.line2",
			"Addresses.city",
			"States.code",
			"Addresses.zip",
			"ServiceRequests.c_ritmNumber",
			"ServiceRequests.c_reqNumber",
			"ServiceRequestTypes.name",
			"TrackingNumbers.number",
			"TrackingNumbers.status",
			"Units.name",
			"Units.serialNumber",
			"Items.partNumber",
			"Items.description",
			"Contacts.firstName",
			"Contacts.lastName",
			"ContactPhoneNumbers.phoneNumber",
			"ContactEmailAddresses.emailAddress",
			"Contacts.c_employeeXid",
		],
		ojoin: [
			{
				AdvanceShippingNoticeItems: {
					"AdvanceShippingNoticeItems.advanceShippingNoticeId":
						"AdvanceShippingNotices.id",
				},
			},
			{
				PurchaseOrders: {
					"PurchaseOrders.id":
						"AdvanceShippingNotices.purchaseOrderId",
				},
			},
			{
				SalesOrders_PurchaseOrders: {
					"SalesOrders_PurchaseOrders.purchaseOrderId":
						"PurchaseOrders.id",
				},
			},
			{
				SalesOrders: {
					"SalesOrders.id": "SalesOrders_PurchaseOrders.salesOrderId",
				},
			},
			{
				ServiceRequests: {
					"ServiceRequests.id": "SalesOrders.serviceRequestId",
				},
			},
			{
				ServiceRequestTypes: {
					"ServiceRequestTypes.id":
						"ServiceRequests.serviceRequestTypeId",
				},
			},
			{
				AdvanceShippingNoticeUnits: {
					"AdvanceShippingNoticeUnits.advanceShippingNoticeItemId":
						"AdvanceShippingNoticeItems.id",
				},
			},
			{
				TrackingNumbers: {
					"TrackingNumbers.id":
						"AdvanceShippingNoticeUnits.trackingNumberId",
				},
			},
			{ Units: { "Units.id": "AdvanceShippingNoticeUnits.unitId" } },
			{ Items: { "Items.id": "Units.itemId" } },
			{ Contacts: { "Contacts.id": "Units.contactId" } },
			{
				Addresses: {
					"Addresses.id": "AdvanceShippingNotices.shipToAddressId",
				},
			},
			{ States: { "States.id": "Addresses.stateId" } },
			{
				PurchaseOrderStages: {
					"PurchaseOrderStages.id":
						"PurchaseOrders.purchaseOrderStageId",
				},
			},
			{
				ContactPhoneNumbers: {
					"ContactPhoneNumbers.id":
						"Contacts.primaryContactPhoneNumberId",
				},
			},
			{
				ContactEmailAddresses: {
					"ContactEmailAddresses.id":
						"Contacts.primaryContactEmailAddressId",
				},
			},
		],
	};

	let allData = [];
	let page = 1;
	let totalRecordCount = 0;

	do {
		options.page = page;
		const response = await togaApiRequest(
			"GET",
			"/advance-shipping-notices",
			null,
			options,
		);

		if (response?.isSuccess) {
			allData = [...allData, ...response.data.advanceShippingNotices];
			totalRecordCount = response.meta.totalRecordCount;
			page++;
		} else {
			break;
		}
	} while (allData.length < totalRecordCount);

	return allData;
}

//invoice PDf details
export async function getInvoicePdf(uuid: string) {
	const options = {
		fields: ["number", "invoicePdfFile"],
		where: {
			and: [{ "Invoices.uuid": { "=": uuid } }],
		},
	};
	const invoicePdfResponse = await togaApiRequest(
		"GET",
		"/invoices",
		null,
		options,
	);
	if (invoicePdfResponse?.isSuccess) {
		return invoicePdfResponse.data.invoices[0];
	}
}

/* -------------------------------------- ORDER DETAILS MODAL ------------------------------------- */

export async function fetchOrdersDetails(uuid: string, fields: string[]) {
	const options = {
		fields: fields,
		ojoin: [
			{
				Items: {
					"Items.id": "SalesOrderItems.itemId",
				},
			},
			{
				Manufacturers: {
					"Manufacturers.id": "Items.manufacturerId",
				},
			},

			{
				PriceTypes: {
					"PriceTypes.id": "SalesOrderItems.priceTypeId",
				},
			},
		],
	} as Options;

	let response = await togaApiRequest(
		"GET",
		"/sales-orders/" + uuid,
		null,
		options,
	);

	return response.data.salesOrders as any;
}

export async function fetchSalesOrderItems(
	uuid: string,
	fields: string[],
): Promise<OrderDetailsResult | undefined> {
	let output: {
		items: any[];
		errorCode?: number;
		errorMessage?: string;
	} = {
		items: [],
	};

	try {
		let options: ExtendedOptionsType = {
			fields: fields,
			recordsPerPage: 50,
			ojoin: [
				{
					Items: {
						"Items.id": "SalesOrderItems.itemId",
					},
				},
				{
					Manufacturers: {
						"Manufacturers.id": "Items.manufacturerId",
					},
				},
				{
					BundleItems: {
						"BundleItems.id": "SalesOrderItems.bundleItemId",
					},
				},
				{
					Bundles: {
						"Bundles.id": "BundleItems.bundleId",
					},
				},
				{
					BundleItemGroups: {
						"BundleItemGroups.id": "BundleItems.bundleItemGroupId",
					},
				},
				{
					PriceTypes: {
						"PriceTypes.id": "SalesOrderItems.priceTypeId",
					},
				},
			],
		};
		let response = await togaApiRequest(
			"GET",
			"/sales-orders/" + uuid + "/sales-order-items",
			null,
			options,
		);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching sales order items.";
				return output;
			}
		}

		output.items = response?.data?.salesOrderItems;
		return output;
	} catch (error: any) {
		console.error("Error fetching sales order items:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}
}

export async function getInvoices(
	uuid: string,
): Promise<OrderDetailsResult | undefined> {
	let output: {
		invoices: any[];
		errorCode?: number;
		errorMessage?: string;
	} = {
		invoices: [],
	};

	try {
		let options: ExtendedOptionsType = {
			fields: [
				"uuid",
				"number",
				"dateInvoice",
				"dateDue",
				"total",
				"amountDue",
				"PaymentTerms.name",
				"status",
			],
			join: [
				{
					SalesOrders: {
						"SalesOrders.id": "Invoices.salesOrderId",
					},
				},
			],
			ojoin: [
				{
					PaymentTerms: {
						"PaymentTerms.id": "Invoices.paymentTermsId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest("GET", "/invoices", null, options);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching invoices.";
				return output;
			}
		}

		output.invoices = response.data.invoices;
		return output;
	} catch (error: any) {
		console.error("Error fetching invoices:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}
}

export async function getShipments(
	uuid: string,
): Promise<OrderDetailsResult | undefined> {
	const storedHostName = localStorage.getItem("hostName");

	let output: {
		salesOrder: OrderDetails | null;
		shipments: any[];
		errorCode?: number;
		errorMessage?: string;
	} = {
		salesOrder: null,
		shipments: [],
	};

	try {
		let options: ExtendedOptionsType = {
			join: [
				{
					ItemFulfillmentPackages: {
						"TrackingNumbers.id":
							"ItemFulfillmentPackages.trackingNumberId",
					},
				},
				{
					ItemFulfillments: {
						"ItemFulfillments.id":
							"ItemFulfillmentPackages.itemFulfillmentId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "ItemFulfillments.salesOrderId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
			fields: [
				"uuid",
				"number",
				"status",
				{
					shippingCarrier: ["name", "urlLogo", "urlLinkPrefix"],
					shippingMethod: ["name"],
				},
			],
		};

		let response;
		if (storedHostName == "PRUDENTIAL") {
			const trackingResponse = await getTrackingNumber(uuid);

			if (
				output.salesOrder &&
				trackingResponse &&
				trackingResponse.length > 0
			) {
				output.salesOrder.trackingNumbers = [
					{
						shippingCarrierId: "1",
						shippingMethodId: null,
						number: trackingResponse[0].number,
						shippingCarrier: {
							name: "FedEx",
							urlLogo: "/carrierlogos/FedEx-logo.svg",
							urlLinkPrefix:
								"https://www.fedex.com/fedextrack/?trknbr=",
						},
						shippingMethod: {
							name: null,
						},
					},
				];
			}
		} else {
			// Getting tracking numbers of sales order
			response = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				options,
			);

			if (!response?.isSuccess) {
				if (response?.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						response.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = response.status || 500;
					output.errorMessage =
						response.error ||
						"An error occurred while fetching tracking numbers.";
					return output;
				}
			}

			const salesOrderTrackingNumbers = response.data.trackingNumbers;

			// Get Invoice Tracking Numbers
			const optionsInvoiceTracking: ExtendedOptionsType = {
				join: [
					{
						InvoiceTrackingNumbers: {
							"InvoiceTrackingNumbers.trackingNumberId":
								"TrackingNumbers.id",
						},
					},
					{
						Invoices: {
							"Invoices.id": "InvoiceTrackingNumbers.invoiceId",
						},
					},
					{
						SalesOrders: {
							"SalesOrders.id": "Invoices.salesOrderId",
						},
					},
				],
				where: {
					and: [{ "SalesOrders.uuid": { "=": uuid } }],
				},
				fields: [
					"number",
					{
						shippingCarrier: ["name", "urlLogo", "urlLinkPrefix"],
						shippingMethod: ["name"],
					},
				],
			};

			// Getting tracking numbers from invoices
			const invoiceTrackingResponse = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				optionsInvoiceTracking,
			);

			if (!invoiceTrackingResponse.isSuccess) {
				if (invoiceTrackingResponse.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						invoiceTrackingResponse.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = invoiceTrackingResponse.status || 500;
					output.errorMessage =
						invoiceTrackingResponse.error ||
						"An error occurred while fetching invoice tracking numbers.";
					return output;
				}
			}

			const invoiceTrackingNumbers =
				invoiceTrackingResponse.data.trackingNumbers;

			// Get Tracking Numbers from ASN
			const optionsASNTracking: ExtendedOptionsType = {
				join: [
					{
						AdvanceShippingNoticeUnits: {
							"AdvanceShippingNoticeUnits.trackingNumberId":
								"TrackingNumbers.id",
						},
					},
					{
						AdvanceShippingNoticeItems: {
							"AdvanceShippingNoticeItems.id":
								"AdvanceShippingNoticeUnits.advanceShippingNoticeItemId",
						},
					},
					{
						AdvanceShippingNotices: {
							"AdvanceShippingNotices.id":
								"AdvanceShippingNoticeItems.advanceShippingNoticeId",
						},
					},
					{
						PurchaseOrders: {
							"PurchaseOrders.id":
								"AdvanceShippingNotices.purchaseOrderId",
						},
					},
					{
						PurchaseOrderItems: {
							"PurchaseOrders.id":
								"PurchaseOrderItems.purchaseOrderId",
						},
					},
					{
						SalesOrderItems_PurchaseOrderItems: {
							"SalesOrderItems_PurchaseOrderItems.purchaseOrderItemId":
								"PurchaseOrderItems.id",
						},
					},
					{
						SalesOrderItems: {
							"SalesOrderItems.id": "SalesOrderItems_PurchaseOrderItems.salesOrderItemId",
						},
					},
					{
						SalesOrders: {
							"SalesOrders.id": "SalesOrderItems.salesOrderId",
						},
					},
				],
				where: {
					and: [{ "SalesOrders.uuid": { "=": uuid } }],
				},
			};

			// Getting tracking numbers from ASN
			const asnTrackingResponse = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				optionsASNTracking,
			);

			if (!asnTrackingResponse?.isSuccess) {
				if (asnTrackingResponse?.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						asnTrackingResponse.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = asnTrackingResponse.status || 500;
					output.errorMessage =
						asnTrackingResponse.error ||
						"An error occurred while fetching ASN tracking numbers.";
					return output;
				}
			}

			const asnTrackingNumbers = asnTrackingResponse.data.trackingNumbers;

			const combinedTrackingNumbers = [
				...salesOrderTrackingNumbers,
				...invoiceTrackingNumbers,
				...asnTrackingNumbers,
			];

			// Filter for unique tracking numbers
			const uniqueTrackingNumbers = combinedTrackingNumbers.reduce(
				(acc: any[], current: any) => {
					if (!acc.find((item) => item.number === current.number)) {
						acc.push(current);
					}
					return acc;
				},
				[],
			);

			output.shipments = uniqueTrackingNumbers;
		}

		return output;
	} catch (error: any) {
		console.error("Error fetching shipments:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}
}

/* ---------------------------------------- APPROVALS  MODAL --------------------------------------- */

export async function getOrderDetails(
	uuid: string,
): Promise<OrderDetailsResult | undefined> {
	const storedHostName = localStorage.getItem("hostName");

	let output: {
		salesOrder: OrderDetails | null;
		items: any[];
		invoices: any[];
		shipments: any[];
		errorCode?: number;
		errorMessage?: string;
	} = {
		salesOrder: null,
		items: [],
		invoices: [],
		shipments: [],
	};

	/* ------------------------------------- Sales Order Header ------------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			join: [
				{
					SalesOrderNotes: {
						"SalesOrderNotes.salesOrderId": "SalesOrders.id",
					},
				},
			],
		};
		let response = await togaApiRequest(
			"GET",
			"/sales-orders/" + uuid,
			null,
			options,
		);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching sales order.";
				return output;
			}
		}

		output.salesOrder = response.data.salesOrders;
	} catch (error: any) {
		console.error("Error fetching sales order header:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* -------------------------------------- Sales Order Items ------------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			fields: [
				"uuid",
				"lineNumber",
				"Bundles.name",
				"Bundles.uuid",
				"BundleItems.uuid",
				"BundleItems.isRequired",
				"BundleItemGroups.name",
				"Items.partNumber",
				"Items.skuNumber",
				"Items.upcCode",
				"Items.description",
				"Manufacturers.name",
				"quantity",
				"_qtyFulfilled",
				"_qtyBilled",
				"_extPrice",
				"price",
				"PriceTypes.name",
				"Items.inventoryType",
			],
			recordsPerPage: 50,
			ojoin: [
				{
					Items: {
						"Items.id": "SalesOrderItems.itemId",
					},
				},
				{
					Manufacturers: {
						"Manufacturers.id": "Items.manufacturerId",
					},
				},
				{
					BundleItems: {
						"BundleItems.id": "SalesOrderItems.bundleItemId",
					},
				},
				{
					Bundles: {
						"Bundles.id": "BundleItems.bundleId",
					},
				},
				{
					BundleItemGroups: {
						"BundleItemGroups.id": "BundleItems.bundleItemGroupId",
					},
				},
				{
					PriceTypes: {
						"PriceTypes.id": "SalesOrderItems.priceTypeId",
					},
				},
			],
		};
		let response = await togaApiRequest(
			"GET",
			"/sales-orders/" + uuid + "/sales-order-items",
			null,
			options,
		);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching sales order items.";
				return output;
			}
		}

		output.items = response?.data?.salesOrderItems;
	} catch (error: any) {
		console.error("Error fetching sales order items:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* ------------------------------------------ Shipments ----------------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			join: [
				{
					ItemFulfillmentPackages: {
						"TrackingNumbers.id":
							"ItemFulfillmentPackages.trackingNumberId",
					},
				},
				{
					ItemFulfillments: {
						"ItemFulfillments.id":
							"ItemFulfillmentPackages.itemFulfillmentId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "ItemFulfillments.salesOrderId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
			fields: [
				"uuid",
				"number",
				"status",
				{
					shippingCarrier: ["name", "urlLogo", "urlLinkPrefix"],
					shippingMethod: ["name"],
				},
			],
		};

		let response;
		if (storedHostName == "PRUDENTIAL") {
			const trackingResponse = await getTrackingNumber(uuid);

			if (
				output.salesOrder &&
				trackingResponse &&
				trackingResponse.length > 0
			) {
				output.salesOrder.trackingNumbers = [
					{
						shippingCarrierId: "1",
						shippingMethodId: null,
						number: trackingResponse[0].number,
						shippingCarrier: {
							name: "FedEx",
							urlLogo: "/carrierlogos/FedEx-logo.svg",
							urlLinkPrefix:
								"https://www.fedex.com/fedextrack/?trknbr=",
						},
						shippingMethod: {
							name: null,
						},
					},
				];
			}
		} else {
			// Getting tracking numbers of sales order
			response = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				options,
			);

			if (!response?.isSuccess) {
				if (response?.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						response.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = response.status || 500;
					output.errorMessage =
						response.error ||
						"An error occurred while fetching tracking numbers.";
					return output;
				}
			}

			const salesOrderTrackingNumbers = response.data.trackingNumbers;

			// Get Invoice Tracking Numbers
			const optionsInvoiceTracking: ExtendedOptionsType = {
				join: [
					{
						InvoiceTrackingNumbers: {
							"InvoiceTrackingNumbers.trackingNumberId":
								"TrackingNumbers.id",
						},
					},
					{
						Invoices: {
							"Invoices.id": "InvoiceTrackingNumbers.invoiceId",
						},
					},
					{
						SalesOrders: {
							"SalesOrders.id": "Invoices.salesOrderId",
						},
					},
				],
				where: {
					and: [{ "SalesOrders.uuid": { "=": uuid } }],
				},
				fields: [
					"number",
					{
						shippingCarrier: ["name", "urlLogo", "urlLinkPrefix"],
						shippingMethod: ["name"],
					},
				],
			};

			// Getting tracking numbers from invoices
			const invoiceTrackingResponse = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				optionsInvoiceTracking,
			);

			if (!invoiceTrackingResponse.isSuccess) {
				if (invoiceTrackingResponse.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						invoiceTrackingResponse.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = invoiceTrackingResponse.status || 500;
					output.errorMessage =
						invoiceTrackingResponse.error ||
						"An error occurred while fetching invoice tracking numbers.";
					return output;
				}
			}

			const invoiceTrackingNumbers =
				invoiceTrackingResponse.data.trackingNumbers;

			// Get Tracking Numbers from ASN
			const optionsASNTracking: ExtendedOptionsType = {
				join: [
					{
						AdvanceShippingNoticeUnits: {
							"AdvanceShippingNoticeUnits.trackingNumberId":
								"TrackingNumbers.id",
						},
					},
					{
						AdvanceShippingNoticeItems: {
							"AdvanceShippingNoticeItems.id":
								"AdvanceShippingNoticeUnits.advanceShippingNoticeItemId",
						},
					},
					{
						AdvanceShippingNotices: {
							"AdvanceShippingNotices.id":
								"AdvanceShippingNoticeItems.advanceShippingNoticeId",
						},
					},
					{
						PurchaseOrders: {
							"PurchaseOrders.id":
								"AdvanceShippingNotices.purchaseOrderId",
						},
					},
					{
						PurchaseOrderItems: {
							"PurchaseOrders.id":
								"PurchaseOrderItems.purchaseOrderId",
						},
					},
					{
						SalesOrderItems: {
							"SalesOrderItems.id":
								"PurchaseOrderItems.salesOrderItemId",
						},
					},
					{
						SalesOrders: {
							"SalesOrders.id": "SalesOrderItems.salesOrderId",
						},
					},
				],
				where: {
					and: [{ "SalesOrders.uuid": { "=": uuid } }],
				},
			};

			// Getting tracking numbers from ASN
			const asnTrackingResponse = await togaApiRequest(
				"GET",
				"/tracking-numbers",
				null,
				optionsASNTracking,
			);

			if (!asnTrackingResponse?.isSuccess) {
				if (asnTrackingResponse?.status === 403) {
					output.errorCode = 403;
					output.errorMessage =
						asnTrackingResponse.error ||
						"Operation Failed: You are not authorized to perform this action.";
					return output;
				} else {
					output.errorCode = asnTrackingResponse.status || 500;
					output.errorMessage =
						asnTrackingResponse.error ||
						"An error occurred while fetching ASN tracking numbers.";
					return output;
				}
			}

			const asnTrackingNumbers = asnTrackingResponse.data.trackingNumbers;

			const combinedTrackingNumbers = [
				...salesOrderTrackingNumbers,
				...invoiceTrackingNumbers,
				...asnTrackingNumbers,
			];

			// Filter for unique tracking numbers
			const uniqueTrackingNumbers = combinedTrackingNumbers.reduce(
				(acc: any[], current: any) => {
					if (!acc.find((item) => item.number === current.number)) {
						acc.push(current);
					}
					return acc;
				},
				[],
			);

			output.shipments = uniqueTrackingNumbers;
		}
	} catch (error: any) {
		console.error("Error fetching shipments:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* ------------------------------------------ Invoices ------------------------------------------ */
	try {
		let options: ExtendedOptionsType = {
			fields: [
				"uuid",
				"number",
				"dateInvoice",
				"dateDue",
				"total",
				"amountDue",
				"PaymentTerms.name",
				"status",
			],
			join: [
				{
					SalesOrders: {
						"SalesOrders.id": "Invoices.salesOrderId",
					},
				},
			],
			ojoin: [
				{
					PaymentTerms: {
						"PaymentTerms.id": "Invoices.paymentTermsId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest("GET", "/invoices", null, options);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching invoices.";
				return output;
			}
		}

		output.invoices = response.data.invoices;
	} catch (error: any) {
		console.error("Error fetching invoices:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* ---------------------------------------- Invoice Items --------------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			fields: [
				"SalesOrderItems.uuid",
				"Invoices.uuid",
				"Invoices.number",
			],
			join: [
				{
					SalesOrderItems: {
						"SalesOrderItems.id": "InvoiceItems.salesOrderItemId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "SalesOrderItems.salesOrderId",
					},
				},
				{
					Invoices: {
						"Invoices.id": "InvoiceItems.invoiceId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest(
			"GET",
			"/invoice-items",
			null,
			options,
		);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching invoice items.";
				return output;
			}
		}

		// Build an array of invoice UUIDs to assign for each sales order item UUID
		const invoiceUuids: { [key: string]: any[] } = {};
		for (const invoiceItem of response.data.invoiceItems) {
			const salesOrderItemUuid = invoiceItem.SalesOrderItems.uuid;
			if (!invoiceUuids[salesOrderItemUuid]) {
				invoiceUuids[salesOrderItemUuid] = [];
			}

			invoiceUuids[salesOrderItemUuid].push({
				uuid: invoiceItem.Invoices.uuid,
				number: invoiceItem.Invoices.number,
			});
		}

		// Bring these into the output.items array
		for (const item of output.items) {
			if (invoiceUuids[item.uuid]) {
				item.invoices = invoiceUuids[item.uuid];
			} else {
				item.invoices = [];
			}
		}
	} catch (error: any) {
		console.error("Error fetching invoice items:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* ----------------------------------- Item Fulfillment Items ----------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			fields: [
				"SalesOrderItems.uuid",
				"TrackingNumbers.uuid",
				"TrackingNumbers.number",
			],
			join: [
				{
					SalesOrderItems: {
						"SalesOrderItems.id":
							"ItemFulfillmentItems.salesOrderItemId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "SalesOrderItems.salesOrderId",
					},
				},
				{
					ItemFulfillments: {
						"ItemFulfillments.id":
							"ItemFulfillmentItems.itemFulfillmentId",
					},
				},
				{
					ItemFulfillmentPackages: {
						"ItemFulfillmentPackages.itemFulfillmentId":
							"ItemFulfillments.id",
					},
				},
				{
					TrackingNumbers: {
						"TrackingNumbers.id":
							"ItemFulfillmentPackages.trackingNumberId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest(
			"GET",
			"/item-fulfillment-items",
			null,
			options,
		);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching item fulfillment items.";
				return output;
			}
		}

		// Build an array of item fulfillment UUIDs to assign for each sales order item UUID
		const itemFulfillmentUuids: { [key: string]: any[] } = {};
		for (const itemFulfillmentItem of response.data.itemFulfillmentItems) {
			const salesOrderItemUuid = itemFulfillmentItem.SalesOrderItems.uuid;
			if (!itemFulfillmentUuids[salesOrderItemUuid]) {
				itemFulfillmentUuids[salesOrderItemUuid] = [];
			}

			itemFulfillmentUuids[salesOrderItemUuid].push({
				uuid: itemFulfillmentItem.TrackingNumbers.uuid,
				number: itemFulfillmentItem.TrackingNumbers.number,
			});
		}

		// Bring these into the output.items array
		for (const item of output.items) {
			if (itemFulfillmentUuids[item.uuid]) {
				item.shipments = itemFulfillmentUuids[item.uuid];
			} else {
				item.shipments = [];
			}
		}
	} catch (error: any) {
		console.error("Error fetching item fulfillment items:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	/* --------------------------------------- Serial Numbers --------------------------------------- */
	try {
		let options: ExtendedOptionsType = {
			fields: ["SalesOrderItems.uuid", "serialNumber"],
			join: [
				{
					ItemFulfillmentItemUnits: {
						"ItemFulfillmentItemUnits.unitId": "Units.id",
					},
				},
				{
					ItemFulfillmentItems: {
						"ItemFulfillmentItems.id":
							"ItemFulfillmentItemUnits.itemFulfillmentItemId",
					},
				},
				{
					SalesOrderItems: {
						"SalesOrderItems.id":
							"ItemFulfillmentItems.salesOrderItemId",
					},
				},
				{
					ItemFulfillments: {
						"ItemFulfillments.id":
							"ItemFulfillmentItems.itemFulfillmentId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "ItemFulfillments.salesOrderId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest("GET", "/units", null, options);

		if (!response?.isSuccess) {
			if (response?.status === 403) {
				output.errorCode = 403;
				output.errorMessage =
					response.error ||
					"Operation Failed: You are not authorized to perform this action.";
				return output;
			} else {
				output.errorCode = response.status || 500;
				output.errorMessage =
					response.error ||
					"An error occurred while fetching serial numbers.";
				return output;
			}
		}

		// Build an array of units by sales order item UUIDs
		const serialNumbersBySalesOrderItemUuid: { [key: string]: string[] } =
			{};
		for (const unit of response.data.units) {
			const salesOrderItemUuid = unit.SalesOrderItems.uuid;
			if (!serialNumbersBySalesOrderItemUuid[salesOrderItemUuid]) {
				serialNumbersBySalesOrderItemUuid[salesOrderItemUuid] = [];
			}

			serialNumbersBySalesOrderItemUuid[salesOrderItemUuid].push(
				unit.serialNumber,
			);
		}

		// Bring these into the output.items array
		for (const item of output.items) {
			if (serialNumbersBySalesOrderItemUuid[item.uuid]) {
				item.serialNumbers =
					serialNumbersBySalesOrderItemUuid[item.uuid];
			} else {
				item.serialNumbers = [];
			}
		}
	} catch (error: any) {
		console.error("Error fetching serial numbers:", error.message);
		output.errorCode = error.response?.status || 500;
		output.errorMessage = error.message || "An unexpected error occurred.";
		return output;
	}

	return formatNumbersInObject(output);
}

export async function fetchOrderItems(uuid: string, fields: string[]) {
	const options = {
		fields: fields,
	};
	let response = await togaApiRequest(
		"GET",
		"/sales-orders/" + uuid,
		null,
		options,
	);
	const salesOrderItems = response?.data?.salesOrders.salesOrderItems;
	return salesOrderItems;
}

// get purchase order number for PO model
export async function fetchPurchaseOrderDetails(uuid: string) {
	try {
		const options: ExtendedOptionsType = {
			join: [
				{
					SalesOrders: {
						"SalesOrders.id":
							"SalesOrders_PurchaseOrders.salesOrderId",
					},
				},
				{
					PurchaseOrders: {
						"PurchaseOrders.id":
							"SalesOrders_PurchaseOrders.purchaseOrderId",
					},
				},
			],
			where: {
				and: [{ "SalesOrders.uuid": { "=": uuid } }],
			},
		};
		let response = await togaApiRequest(
			"GET",
			`/sales-order-purchase-orders`,
			null,
			options,
		);

		return response.data.salesOrderPurchaseOrders;
	} catch (error: any) {
		console.error("Error fetching purchase order details:", error.message);
		throw error;
	}
}

// Create purchase order for PO model
export async function addPurchaseOrderInputAndCreditCardInfo(
	salesOrderUuid: string,
	purchaseOrderNumber: string,
	customerUuid: string,
	dateOrder: string,
	purchaseOrderUuid: string | null,
	c_requiresCreditCard: boolean = false,
) {
	try {
		// purchase order payload
		const payload = {
			number: purchaseOrderNumber,
			customer: {
				uuid: customerUuid,
			},
			dateOrder: dateOrder,
			c_requiresCreditCard: c_requiresCreditCard ? 1 : 0,
			salesOrderPurchaseOrders: [
				{
					salesOrder: {
						uuid: salesOrderUuid,
					},
				},
			],
		};

		let endpoint;
		let method;
		if (purchaseOrderUuid) {
			endpoint = `/purchase-orders/${purchaseOrderUuid}`;
			method = "PUT";
		} else {
			endpoint = "/purchase-orders";
			method = "POST";
		}

		const response = await togaApiRequest(method, endpoint, payload);

		if (!response?.isSuccess) {
			throw new Error(
				response?.error || "Failed to create purchase order",
			);
		}

		return response;
	} catch (error: any) {
		console.error("Error creating purchase order:", error.message);
		throw error;
	}
}

// Update purchase order number for PO model
export async function updatePurchaseOrderNumber(
	purchaseOrderUuid: string,
	newPurchaseOrderNumber: string,
) {
	try {
		const payload = {
			number: newPurchaseOrderNumber,
		};

		const response = await togaApiRequest(
			"PUT",
			`/purchase-orders/${purchaseOrderUuid}`,
			payload,
		);

		if (!response?.isSuccess) {
			throw new Error(
				response?.error || "Failed to update purchase order number",
			);
		}

		return response;
	} catch (error: any) {
		console.error("Error updating purchase order number:", error.message);
		throw error;
	}
}

// Getting tracking number using Purchase Order UUID for Prudential
export async function getTrackingNumber(uuid: string) {
	const options: ExtendedOptionsType = {
		fields: ["uuid", "number"],
		join: [
			{
				AdvanceShippingNoticeUnits: {
					"AdvanceShippingNoticeUnits.trackingNumberId":
						"TrackingNumbers.id",
				},
			},
			{
				AdvanceShippingNoticeItems: {
					"AdvanceShippingNoticeItems.id":
						"AdvanceShippingNoticeUnits.advanceShippingNoticeItemId",
				},
			},
			{
				AdvanceShippingNotices: {
					"AdvanceShippingNotices.id":
						"AdvanceShippingNoticeItems.advanceShippingNoticeId",
				},
			},
			{
				PurchaseOrders: {
					"PurchaseOrders.id":
						"AdvanceShippingNotices.purchaseOrderId",
				},
			},
			{
				PurchaseOrders_SalesOrders: {
					"PurchaseOrders_SalesOrders.purchaseOrderId":
						"PurchaseOrders.id",
				},
			},
			{
				SalesOrders: {
					"SalesOrders.id": "PurchaseOrders_SalesOrders.salesOrderId",
				},
			},
		],
		where: {
			and: [{ "SalesOrders.uuid": { "=": uuid } }],
		},
	};

	const response = await togaApiRequest(
		"GET",
		"/tracking-numbers",
		null,
		options,
	);

	if (response?.isSuccess) {
		return response.data.trackingNumbers;
	} else {
		console.log(":(");
	}
}

export async function updateSalesOrderNotes(
	salesOrderUuid: string,
	contactUuid: number,
	memo: string,
	salesOrderNoteType: string,
) {
	var userOptions = {
		join: [
			{
				Contacts: {
					"Contacts.id": "Users.contactId",
				},
			},
		],
		fields: ["contactId", "Contacts.uuid"],
		where: {
			and: [{ "Users.uuid": { "=": contactUuid } }],
		},
	};
	var fetchResponse = await togaApiRequest(
		"GET",
		"/users",
		null,
		userOptions,
	);

	let contactId = fetchResponse.data?.users[0]?.contactId;
	let contactUuidParam = fetchResponse.data?.users[0]?.Contacts.uuid;

	const data = {
		salesOrder: { uuid: salesOrderUuid },
		salesOrderNoteType: { slug: salesOrderNoteType },
		contact: { uuid: contactUuidParam },
		dtStamp: "NOW()",
		note: memo,
	};
	const response = await togaApiRequest("POST", "/sales-order-notes/", data, {
		depth: 1,
	});
	var output = response.data;
}

// Getting Sales order details View
function formatNumbersInObject(obj) {
	if (Array.isArray(obj)) {
		return obj.map(formatNumbersInObject);
	} else if (typeof obj === "object" && obj !== null) {
		const formattedObject = {};
		Object.entries(obj).forEach(([key, value]) => {
			formattedObject[key] = formatNumbersInObject(value);
		});
		return formattedObject;
	} else if (typeof obj === "number") {
		// Keep as a string to preserve two decimal places
		return obj.toFixed(2);
	}
	return obj;
}

export async function getSearchValuesFromAdvancedInput(
	limit: number,
	page: number,
	value: string,
	searchForSpecificRole: string[] | null = null,
) {
	const userOptions = {
		recordsPerPage: limit,
		page: page,
		fields: ["uuid", "_name", "email"],
		sort: ["_name"],
		join: [
			{
				Users_Roles: {
					"Users.id": "Users_Roles.userId",
				},
			},
			{
				Roles: {
					"Roles.id": "Users_Roles.roleId",
				},
			},
		],
		where: {
			and: [
				{
					or: [
						{ "Users.firstName": { like: `%${value}%` } },
						{ "Users.lastName": { like: `%${value}%` } },
						{ _name: { like: `%${value}%` } },
						{ "Users.email": { like: `${value}%` } },
					],
				},
			],
		},
	};

	if (searchForSpecificRole) {
		userOptions.where.and.push({
			or: searchForSpecificRole.map((role) => ({
				"Roles.name": { "=": role },
			})),
		});
	}

	let allUsers: any[] = [];
	// let page = 1; // Starting from page 1
	let totalRecordCount = 0; // Initialize total count
	let hasNextPage = true;

	try {
		userOptions.page = page;

		const userResponse = await togaApiRequest(
			"GET",
			"/users",
			null,
			userOptions,
		);

		if (userResponse?.isSuccess) {
			const { data, meta } = userResponse;

			// Append users to the overall list
			allUsers = [...allUsers, ...data.users];

			// Update totalRecordCount and log for debugging
			totalRecordCount = meta?.totalRecordCount || 0;

			// Check if there is a next page or if we've fetched enough users
			hasNextPage = !!meta?.nextPage && allUsers.length < limit;

			// Increment page for the next iteration
			page++;
		} else {
			console.error("Error fetching user data", userResponse);
			hasNextPage = false; // Exit loop on failure
			// }
		}

		return allUsers;
	} catch (error) {
		console.error("Error fetching data:", error);
		return [];
	}
}

export async function getAdminsAndManagers(limit: number, page: number) {
	const userOptions = {
		recordsPerPage: limit,
		page: page,
		fields: ["uuid", "_name", "email"],
		sort: ["_name"],
		join: [
			{
				Users_Roles: {
					"Users.id": "Users_Roles.userId",
				},
			},
			{
				Roles: {
					"Roles.id": "Users_Roles.roleId",
				},
			},
		],
		where: {
			and: [
				{ "Users.isActive": { "=": "1" } },
				{
					or: [
						{ "Roles.name": { "=": "Admin" } },
						{ "Roles.name": { "=": "Manager" } },
					],
				},
			],
		},
	};

	let allUsers: any[] = [];
	// let page = 1; // Starting from page 1
	let totalRecordCount = 0; // Initialize total count
	let hasNextPage = true;

	try {
		// while (hasNextPage && allUsers.length < limit) {
		// Update the user options with the current page
		userOptions.page = page;

		const userResponse = await togaApiRequest(
			"GET",
			"/users",
			null,
			userOptions,
		);

		if (userResponse?.isSuccess) {
			const { data, meta } = userResponse;

			// Append users to the overall list
			allUsers = [...allUsers, ...data.users];

			// Update totalRecordCount and log for debugging
			totalRecordCount = meta?.totalRecordCount || 0;

			// Check if there is a next page or if we've fetched enough users
			hasNextPage = !!meta?.nextPage && allUsers.length < limit;

			// Increment page for the next iteration
			page++;
		} else {
			console.error("Error fetching user data", userResponse);
			hasNextPage = false; // Exit loop on failure
			// }
		}

		return allUsers.slice(0, limit); // Return only the first `limit` users
	} catch (error) {
		console.error("Error fetching data:", error);
		return [];
	}
}

export async function getAdmins() {
	const userOptions = {
		fields: ["uuid", "_name", "email"],
		recordsPerPage: 1000,
		join: [
			{
				Users_Roles: {
					"Users.id": "Users_Roles.userId",
				},
			},
			{
				Roles: {
					"Roles.id": "Users_Roles.roleId",
				},
			},
		],

		where: {
			and: [
				{ "Roles.name": { "=": "Admin" } },
				{ clientId: { "=": null } },
			],
		},
	};

	const userResponse = await togaApiRequest(
		"GET",
		"/users",
		null,
		userOptions,
	);

	return userResponse.data.users;
}

// This function is used to get child bundle data in the approvals modal to format bundles correctly
export async function fetchSingleChildBundleData(uuid: string) {
	const options = {
		fields: [
			"uuid",
			"name",
			"number",
			"_imageUrl",
			"_bundleMicroImages",
			"_bundleUnitPrice",
			"_bundleLeasePrice",
			"description",
			"bundleItems.uuid",
			"bundleItems.sortOrder",
			"bundleItems.isActive",
			"bundleItems.isVisible",
			"bundleItems.isRequired",
			"bundleItems.maxOrderQuantity",
			"bundleItems.minOrderQuantity",
			"bundleItems._unitPrice",
			"bundleItems._leasePrice",
			"bundleItems.defaultPriceType.slug",
			"bundleItems.bundleItemGroup.uuid",
			"bundleItems.bundleItemGroup.slug",
			"bundleItems.bundleItemGroup.name",
			"bundleItems.item.uuid",
			"bundleItems.item.partNumber",
			"bundleItems.item.title",
			"bundleItems.item.description",
			"bundleItems.item.longDescription",
			"bundleItems.item.skuNumber",
			// "bundleItems.item._imageUrl",
			"bundleItems.item._leasePrice",
			"bundleItems.item._unitPrice",
			"bundleItems.item.isActive",
			"bundleItems.item.isVisible",
			"bundleItems.item.manufacturer.uuid",
			"bundleItems.item.manufacturer.name",
			"bundleItems.item.assetType.uuid",
			"bundleItems.item.assetType.name",
			"bundleItems.item.itemCategory.uuid",
			"bundleItems.item.itemCategory.name",
		],
		where: {
			and: [{ "BundlesItems.isActive": { "=": "true" } }],
		},
	} as Options;

	try {
		// throw new Error("Hardcoded error for testing purposes");s

		const response = await togaApiRequest(
			"GET",
			"/bundles/" + uuid,
			null,
			options,
		);

		return response.data.bundles;
	} catch (error) {
		if (error instanceof Error) {
			const statusCode = (error as { [key: string]: any }).status || 500; // Default to 500 if status is not set
			console.error(
				`Error fetching bundle data (status ${statusCode}):`,
				error.message,
			);
			throw { status: statusCode, message: error.message };
		} else {
			console.error("Unknown error bundle data:", error);
			throw error;
		}
	}
}
